import { render, staticRenderFns } from "./UcRegisterEntryInvoiceSelector.yaml?vue&type=template&id=2d408727&component"
import script from "./UcRegisterEntryInvoiceSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcRegisterEntryInvoiceSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports